import { useMutation, useQueryClient } from "react-query";
import axios from "../axios";

type CreatePengeluaranBody = {
    ukmId: string;
    tanggal: string | null;
    nama: string;
    totalNominal: string | number;
    kode?: string;
};

type CreatePengeluaranResponse = {
    code: number;
    message?: string;
};

const createPengeluaran = async (body: CreatePengeluaranBody) => {
    const response = await axios.post<CreatePengeluaranResponse>(
        "/api/biaya",
        body,
    );
    return response.data;
};

export default function useCreatePengeluaran() {
    const queryClient = useQueryClient();

    return useMutation(
        (body: CreatePengeluaranBody) => createPengeluaran(body),
        {
            onSuccess: () => {
                queryClient.invalidateQueries(["pengeluaran"]);
                queryClient.invalidateQueries(["laporan-laba-rugi"]);
            },
        },
    );
}
